import { PlessViewUtilsSub } from './../../../commons/kymw00/pless-view-utils-sub.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';

import { Menu } from '@grapecity/wijmo.input';
// import { CellRange, FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { CellRange, FlexGrid, SelectionMode, CellType } from '@grapecity/wijmo.grid';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW9000Model } from './kymw9000.model';
import { KYMW9005Component } from '../kymw9005/kymw9005.component';
import { KYMW9005InputModel } from '../kymw9005/vo/kymw9005-input.model';
import { GetAuthoritySetListService } from '../kymw9003/api-services/get-authority-set-list.service';
import { GetAssociatedUserManagementListService } from './api-services/get-associated-user-management-list.service';
import { GetAssociatedUserTypeService } from './api-services/get-associated-user-type.service';
import { DeleteAssociatedUserManagementSevice } from './api-services/delete-associated-user-management.service';
import { AuthoritySetIDModel } from './vo/authority-set-id.model';
import { EventArgs } from '@grapecity/wijmo';
import { KYMW9000InputVO } from './vo/kymw9000-input.model';
import { FuncPermission } from '../../kymw10/kymw1000/vo/login-user-info.model';
import { KYMW9003Model } from '../kymw9003/kymw9003.model';

/**
 * ユーザ管理画面を管理するクラス
 *
 * @export KYMW9000Component
 * @class KYMW9000Component
 */
@Component({
  selector: 'app-kymw9000',
  templateUrl: 'kymw9000.component.html',
  styleUrls: ['kymw9000.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9000Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw9000Model: KYMW9000Model = new KYMW9000Model();
  kymw9003Model: KYMW9003Model = new KYMW9003Model();

  @ViewChild('dg_AuthoritySet', { static: true }) dg_AuthoritySet: FlexGrid;
  @ViewChild('dgt_associatedUserManagementList', { static: true }) dgt_associatedUserManagementList: FlexGrid;
  @ViewChild('btn_regist', { static: true }) btn_regist: ElementRef;
  @ViewChild('cmb_userType', { static: true }) cmb_userType: ElementRef;

  // コンテキストメニュー(右クリック)
  private contextMenuUser: Menu;

  /** モーダルから復帰時の再検索要否確認用フラグ */
  public searchFlag: Boolean = <boolean>false;

  /**
   * Creates an instance of KYMW9000Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {GetAuthoritySetListService} getAuthoritySetListService
   * @param {DeleteAuthoritySetService} deleteAuthoritySetService
   * @memberof KYMW9000Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    public getAuthoritySetListService: GetAuthoritySetListService,
    public getAssociatedUserManagementListService: GetAssociatedUserManagementListService,
    public getAssociatedUserTypeService: GetAssociatedUserTypeService,
    public deleteAssociatedUserManagementSevice: DeleteAssociatedUserManagementSevice,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW9000Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9000';
    this.kymw9000Model.kymw9000Component = this;

    // ユーザ区分を取得する
    this.getAssociatedUserTypeService.execute(this.kymw9000Model);

    // 権限セットを取得する
    // 有効な権限のみ取得
    this.kymw9003Model.authorityStatus = '0';
    this.getAuthoritySetListService.execute(this.kymw9003Model, () => {
      this.kymw9000Model.authoritySetList = this.kymw9003Model.authoritySetList;
    });

    // コンテキストメニュー設定
    this.setContextMenuUser();

    // 行ヘッダの幅を0にしてレイアウト設定
    this.dgt_associatedUserManagementList.rowHeaders.columns[0].width = 0;
    this.dgt_associatedUserManagementList.selectionMode = SelectionMode.Row;

    // グリッドの初期選択行はなしとする
    this.dgt_associatedUserManagementList.itemsSourceChanged.addHandler((sender: FlexGrid, event: EventArgs) => {
      this.dgt_associatedUserManagementList.select(-1, -1);
    });

    // フルコントロール以外のとき「新規登録」ボタンを非活性にする
    if (this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {
      this.kymw9000Model.btnRegistEnabled = false;
    }

    // 初期フォーカス設定
    this.cmb_userType.nativeElement.focus();
  }

  /**
   * ユーザ一覧のコンテキストメニューで「ユーザ情報編集」が選択されたときのイベント
   *
   * @memberof KYMW9000Component
   */
  public eventDgtAssociatedUserManagementListEdit_CLICKHandler(): void {
    // 「ユーザー情報詳細ポップアップ用インプットVO」の生成
    const vo: KYMW9005InputModel = new KYMW9005InputModel();
    // VOに値を設定
    vo.associatedUserId = this.getSelectedUserID();	// ユーザーID

    // ユーザ情報設定画面を呼び出す
    this.openKYMW9005(vo);
  }

  /**
   * 新規登録ボタンが押されたときのイベント
   *
   * @memberof KYMW9000Component
   */
  public eventDgtAssociatedUserManagementListAdd_CLICKHandler(): void {
    // 「ユーザー情報詳細ポップアップ用インプットVO」の生成
    const vo: KYMW9005InputModel = new KYMW9005InputModel();
    vo.associatedUserId = '';

    // ユーザ情報設定画面を呼び出す
    this.openKYMW9005(vo);
  }

  /**
   * ユーザ情報設定を呼び出す
   */
  public openKYMW9005(vo: KYMW9005InputModel) {
    // ｢ユーザー情報詳細｣画面を呼び出す。
    const componentRef = this.dialogService.openModal(KYMW9005Component);
    const instance = componentRef.componentInstance as KYMW9005Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
      // 再検索要否を確認する
      if ( this.searchFlag ) {
        let reqvo = this.getAssociatedUserManagementList();
        this.getAssociatedUserManagementListService.execute(this.kymw9000Model, reqvo);
      }
    };
  }

  /**
   * ユーザ一覧のコンテキストメニューで「ユーザー情報削除」が選択されたときのイベント
   *
   * @memberof KYMW9000Component
   */
  public eventDgtAssociatedUserManagementListDel_CLICKHandler(): void {
    // 有効/無効区分が「無効」以外の場合、エラーメッセージ
    if ( this.dgt_associatedUserManagementList.selectedItems[0].isEnabled !== "無効" ) {
      this.dialogService.openAlertGetMessage('E0567');
      return;
    }
    // メッセージを表示する
    this.dialogService.openAlertGetMessage('Q0178', [''],
      (closeDetail) => {
        // OKボタン押下時
        if (closeDetail === PlessAlert.Yes) {
          // 選択したユーザーを削除する。
          const vo = this.kymw9000Model.createUserIDVO();
          this.deleteAssociatedUserManagementSevice.execute(this.kymw9000Model, vo,
            (data:any) => this.eventdeleteAssociatedUserManagementSuccessFunc()
          );
        }
      },
    );
  }

  /**
   * 選択されているユーザーIDを取得する
   *
   * @returns {string} 選択されているユーザー一覧のユーザーID
   * @memberof KYMW9000Component
   */
  public getSelectedUserID(): string {
    return this.dgt_associatedUserManagementList.selectedItems[0].associatedUserId;
  }

  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns {*}
   * @memberof KYMW9000Component
   */
  private getFormatContextMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * ユーザー・コンテキストメニューを追加
   *
   * @private
   * @memberof KYMW9000Component
   */
  private setContextMenuUser(): void {
    this.contextMenuUser = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: 'ユーザ情報編集', cmd: 'UserEdit', enabled: true },
          { caption: 'ユーザ情報削除', cmd: 'UserDelete', enabled: true },
        ],
        command: this.getFormatContextMenuCommand(),
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.contextMenuUser.selectedValue) {
            case 'UserEdit':
              this.eventDgtAssociatedUserManagementListEdit_CLICKHandler();
              break;
            case 'UserDelete':
              this.eventDgtAssociatedUserManagementListDel_CLICKHandler();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dgt_associatedUserManagementList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.contextMenuUser !== undefined) {
        this.eventDgtAssociatedUserManagementListContextMOUSE_CLICKHandler(e);
        this.contextMenuUser.show(e);
      }
    });
  }

  /**
 * ユーザ一覧グリッドクリックイベント
 *
 * @memberof KYMW9000Component
 */
  public eventDgtAssociatedUserManagementListContextMOUSE_CLICKHandler(e): void {
    // コンテキストメニューの利用可能不可判断フラグ
    let contextMenuEnabledMode = Boolean(true);

    const ht = this.dgt_associatedUserManagementList.hitTest(e.pageX, e.pageY);
    if (ht.cellType === CellType.Cell) {
      // 右クリック押下時に対象行を選択状態にする
      const grid = new CellRange(ht.row, ht.col);
      this.dgt_associatedUserManagementList.select(grid, false);
    }

    // フルコントロール以外の時は、コンテキストメニュー非活性
    if (this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {
      contextMenuEnabledMode = false;
    } else {
      if (ht.cellType !== CellType.Cell || (PlessViewUtilsSub.isEmptyArray(this.dgt_associatedUserManagementList.selectedRows))) {
        // 行がない時は非活性
        contextMenuEnabledMode = false;
      }
    }
    for (const contextMenuItem of this.contextMenuUser.itemsSource) {
      contextMenuItem.enabled = contextMenuEnabledMode;
    }
  }
  
  /**
   * 表示ボタン押下
   */
  public eventBtnDisplay_CLICKHandler(pageNo: number):void {
    this.kymw9000Model.page = pageNo;
    const reqVO = this.getAssociatedUserManagementList();
    this.getAssociatedUserManagementListService.execute(this.kymw9000Model, reqVO, (data)=> {
      if (this.kymw9000Model.associatedUserManagementList == null || 
          this.kymw9000Model.associatedUserManagementList.length === 0) {
        this.dialogService.openAlertGetMessage("W0049");
      }
    });
  }

  /**
   * ユーザ一覧取得VO初期化
   * 
   */
  public getAssociatedUserManagementList() {
    const reqVO: KYMW9000InputVO = new KYMW9000InputVO();
    reqVO.associatedUserType = PlessViewUtilsSub.nullToBlank( this.kymw9000Model.associatedUserType );
    reqVO.associatedUserName = PlessViewUtilsSub.nullToBlank( this.kymw9000Model.associatedUserName );
    reqVO.emailAddress = PlessViewUtilsSub.nullToBlank( this.kymw9000Model.emailAddress );
    reqVO.authoritySetId = PlessViewUtilsSub.nullToBlank ( this.kymw9000Model.authoritySetId );
    reqVO.associatedCompanyName = PlessViewUtilsSub.nullToBlank( this.kymw9000Model.associatedCompanyName );
    reqVO.isEnabled = this.kymw9000Model.isEnabled;
    reqVO.page = this.kymw9000Model.page;

    return reqVO;
  }

  /**
   * 削除API成功後処理
   * 
   */
  public eventdeleteAssociatedUserManagementSuccessFunc() {
    this.dialogService.openAlertGetMessage('I0515', [''], 
      (closeDetail) => {
        // OKボタン押下時
        if (closeDetail === PlessAlert.Yes) {
          const reqVO = this.getAssociatedUserManagementList();
          // 再検索
          this.getAssociatedUserManagementListService.execute(this.kymw9000Model, reqVO);
        }
      }
    )
  }

  /**
   * 前へをクリックした時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventBackHandler(): void {
    // 現在のページ番号-1を設定し、リストを取得
    const pageNo = (this.kymw9000Model.page <= 1) ? 1 : this.kymw9000Model.page - 1;
    this.kymw9000Model.page = pageNo;
    const reqVO = this.getAssociatedUserManagementList();
    this.getAssociatedUserManagementListService.execute(this.kymw9000Model, reqVO);
  }

  /**
   * 次へをクリックした時に呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventNextHandler(): void {
    // 現在のページ番号+1を設定し、リストを取得
    const pageNo = (this.kymw9000Model.page < 1) ? 1 : this.kymw9000Model.page + 1;
    this.kymw9000Model.page = pageNo;
    const reqVO = this.getAssociatedUserManagementList();
    this.getAssociatedUserManagementListService.execute(this.kymw9000Model, reqVO);
  }
}
